import { render, staticRenderFns } from "./PaymentMethodCardBrand.vue?vue&type=template&id=0772a5b4&scoped=true&"
import script from "./PaymentMethodCardBrand.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodCardBrand.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodCardBrand.vue?vue&type=style&index=0&id=0772a5b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0772a5b4",
  null
  
)

export default component.exports